module.exports = __webpack_public_path__ + "img/good1.f3587149.jpg";